import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PlataformaFormulariosDinamicosComponent } from './plataforma-formularios-dinamicos.component';
import { CabecalhoEsquerdaModule } from '../../components/cabecalho/cabecalho-esquerda/cabecalho-esquerda.module';
import { BeneficioEsquerdaModule } from '../../components/beneficio/beneficio-esquerda/beneficio-esquerda.module';
import { BeneficioDireitaModule } from '../../components/beneficio/beneficio-direita/beneficio-direita.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';

@NgModule({
  declarations: [
    PlataformaFormulariosDinamicosComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoEsquerdaModule,
    BeneficioEsquerdaModule,
    BeneficioDireitaModule,
    SolucoesModule
  ],
  exports: [
    PlataformaFormulariosDinamicosComponent
  ]
})

export class PlataformaFormulariosDinamicosModule { }
